import * as angular from "angular";
import * as _ from "lodash"

/* @ngInject */
function jobPackageItems() {
  return function jobPackageItemsFilter(job, defaultValue) {

    let items = 0;

    if (_.get(job, 'packages.length')) {
      items = _.reduce(job.packages, function (sum, p) {
        return sum + _.get(p, 'count', 0);
      }, 0);
    }

    if (!items) {
      return defaultValue || '--'
    }

    return items;
  }
}

angular
  .module('bringoz.admin.planning')
  .filter('jobPackageItems', jobPackageItems);
